export default {"src":"/_next/static/media/fingerprint_white.b8eae674.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};